import { render } from "./ListHouses.vue?vue&type=template&id=855b28d8&scoped=true&ts=true&lang=pug"
import script from "./ListHouses.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListHouses.vue?vue&type=script&lang=ts&setup=true"

import "./ListHouses.vue?vue&type=style&index=0&id=855b28d8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-855b28d8"]])

export default __exports__